import React from 'react';
import { Button, Grid, TextField, Card, CardContent, Box } from '@mui/material';
import FilterSelectInput from '../../../sharedModules/form/components/FilterSelectInput';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';

interface CustomerIssuesFilterProps {
  filterValues: Record<string, string>;
  setFilterValues: React.Dispatch<any>;
  onFilter: (filterValues: any) => void;
}

const CustomerIssuesFilter: React.FC<CustomerIssuesFilterProps> = (props) => {
  const { filterValues, setFilterValues, onFilter } = props;

  const handleFiltersKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') onFilter(filterValues);
  };

  const handleFilterChange = (key: string, value: string) => {
    const updatedFilterValues = { ...filterValues, [key]: value };
    setFilterValues(updatedFilterValues);

    // Auto-filter on dropdown changes
    if (['resolved_eq', 'db_location_eq'].includes(key)) {
      onFilter(updatedFilterValues);
    }
  };

  const handleClear = () => {
    const clearedFilters = {
      resolved_eq: 'all',
      db_location_eq: 'all',
    };
    setFilterValues(clearedFilters);
    onFilter(clearedFilters);
  };

  const handleApply = () => {
    onFilter(filterValues);
  };

  return (
    <Card elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, mb: 3 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center" onKeyDown={handleFiltersKeyPress}>
          <Grid item xs={12} sm={6} md={3}>
            <FilterSelectInput
              value={filterValues?.resolved_eq || 'all'}
              choices={[
                { label: 'All Statuses', value: 'all' },
                { label: 'Open', value: 'N' },
                { label: 'Resolved', value: 'Y' },
              ]}
              valueChanged={(value) => handleFilterChange('resolved_eq', value)}
              label="Status"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <FilterSelectInput
              value={filterValues?.db_location_eq || 'all'}
              choices={[
                { label: 'All Locations', value: 'all' },
                { label: 'Pittsburgh', value: 'pittsburgh' },
                { label: 'Tampa', value: 'tampa' },
              ]}
              valueChanged={(value) => handleFilterChange('db_location_eq', value)}
              label="Location"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{ display: 'flex', gap: 1, height: '100%', alignItems: 'flex-end', pb: 0.5 }}>
              <Button variant="outlined" startIcon={<FilterListIcon />} onClick={handleApply} sx={{ flex: 1 }}>
                Apply
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                startIcon={<ClearIcon />}
                onClick={handleClear}
                sx={{ flex: 1 }}
              >
                Clear
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CustomerIssuesFilter;
